<template>
  <div class="d-flex p-3 text-white bg-blur-darker justify-content-between align-items-center">
    <h5 class="mb-0">{{ header }}</h5>
    <button class="btn d-lg-none text-light me-3" type="button" @click.prevent="$parent.$emit('showNav')">
      <i class="fas fa-bars"></i>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TabHeader",
  props: {
    header: {
      type: String,
      required: true,
    },
  },
});
</script>
